// extracted by mini-css-extract-plugin
export default {"container":"GO","productarea":"HO","btn":"IO","promowrapper":"JO","upsellarea":"KO","subtitle":"LO","system":"MO","desc":"NO","cardswrap":"OO","cards":"PO","squareloadingcontainer":"QO","squareloading33":"RO"};
    if(module.hot) {
      // 1721922365182
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  